module.exports = __webpack_public_path__ + "assets/sounds/ReceivedMessage-f18b46.wav";